const { React, ReactDOM } = window;
function GalleryContainer({
  current,
  images: imagesProp,
  onClose,
  onSetCurrent,
}) {
  let open = current !== null;
  let images = [];

  React.useEffect(() => {
    function handleKeyPress(evt) {
      if (current !== null) {
        if (evt.key === "Escape") {
          onClose();
        } else if (evt.key === "ArrowLeft") {
          onSetCurrent(current - 1);
        } else if (evt.key === "ArrowRight") {
          onSetCurrent(current + 1);
        }
      }
    }

    addEventListener("keyup", handleKeyPress);

    return () => removeEventListener("keyup", handleKeyPress);
  }, [current]);

  if (open) {
    let previous = current <= 0 ? imagesProp.length - 1 : current - 1;
    let next = current >= imagesProp.length - 1 ? 0 : current + 1;

    images.push(imagesProp[previous]);
    images.push(imagesProp[current]);
    images.push(imagesProp[next]);
  }

  return (
    <div
      className={(open ? "in " : "") + "gallery-container"}
      style={{ display: open ? "block" : "none" }}
    >
      <div className="counter"></div>
      <button
        className="close-btn"
        aria-label="Lukk bildegalleri"
        onClick={onClose}
      >
        &times;
      </button>
      <button
        className="prev-btn"
        aria-label="Forrige bilde"
        onClick={() => onSetCurrent(current - 1)}
      ></button>
      <button
        className="next-btn"
        aria-label="Neste bilde"
        onClick={() => onSetCurrent(current - 1)}
      ></button>
      {images.map((image, index) => {
        let classes = "gallery-image";
        if (index === 0) {
          classes += " prev";
        } else if (index === 2) {
          classes += " next";
        }

        return (
          <div className={classes} key={image.href}>
            <img src={image.url} alt={image.alt} />
          </div>
        );
      })}
    </div>
  );
}

function GalleryThumbnails({ images, onClick }) {
  return (
    <ul className="gallery">
      {images.map((image, index) => (
        <li key={image.url}>
          <a href={image.url} onClick={(evt) => onClick(evt, index)}>
            <img src={image.url + "?width=150&height=150"} alt={image.alt} />
          </a>
        </li>
      ))}
    </ul>
  );
}

function GalleryRoot({ images = [] }) {
  let [current, setCurrent] = React.useState(null);

  function handleClickThumbnail(evt, index) {
    evt.preventDefault();
    setCurrent(index);
  }

  function handleSetCurrent(index) {
    if (index >= images.length - 1) {
      setCurrent(0);
    } else if (index <= 0) {
      setCurrent(images.length - 1);
    } else {
      setCurrent(index);
    }
  }

  return (
    <>
      <GalleryContainer
        images={images}
        current={current}
        onSetCurrent={handleSetCurrent}
        onClose={() => setCurrent(null)}
      />
      <GalleryThumbnails images={images} onClick={handleClickThumbnail} />
    </>
  );
}

function initGalleries() {
  let galleries = document.querySelectorAll(".gallery");
  for (let gallery of galleries) {
    let images = gallery.querySelectorAll("a");
    let cImages = [];
    let root = document.createElement("div");

    for (let image of images) {
      let img = image.querySelector("img");
      cImages.push({ alt: img.alt, url: image.href });
    }

    gallery.parentElement.replaceChild(root, gallery);

    ReactDOM.render(<GalleryRoot images={cImages} />, root);
  }
}

document.addEventListener("DOMContentLoaded", initGalleries);
